// extracted by mini-css-extract-plugin
export default {"content":"PageContent-content-C67P9"};